import { DROP_MENU_SHOW_HIDE, SIDE_MENU_SHOW_HIDE} from '../constants'
import {handleActions} from 'redux-actions';

export const menu = handleActions({
    [DROP_MENU_SHOW_HIDE]: (state) =>({mobile: !state.modal}),
    [SIDE_MENU_SHOW_HIDE]: (state, action) =>({desktop: action.payload})
},{desktop: false, mobile: false});